import React, { useState, useEffect, useRef } from 'react';
// import SummaryListingComponent from "./SummaryListingComponent";
import PlusIcon from "./../../images/plus-rounded-14.svg";
import { Redirect } from 'react-router';
import { DELETE_CONFIRMATION_BOX_CONTENT, QUICK_EDITOR, EDUCATION_LINK, EDUCATION_TIPS_LINK, FINAL_RESUME, HEADING_LINK, NEXT_EDUCATION_LABEL, NEXT_LABEL, NEXT_SKILLS_LABEL, NEXT_SUMMARY_LABEL, NEXT_WORKHISTORY_LABEL, POPUP_TYPES, SKILLS_LINK, SKILL_TIPS_LINK, SKIP_CONFIRMATION_BOX_CONTENT, WORKHISTORY_LINK } from '../../constants/constants';
import DeleteIcon from '../../assets/images-new/icons/bin-icon.svg';
import DraggableIcon from '../../assets/images/draggable-icon.svg';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import AddEducation from './AddEducation';
import QuickTips from '../common/QuickTips';
import { useResume } from '../../context/ResumeContext';
import { usePopup } from '../../context/PopupContext';
import { getExcerpt, removeBodyScroll, formatDateHelper, rotateQuickTipsPopup, setBodyHeight } from '../../helper';

const Summary = (props) => {
    const emptyeducation = {
        school_name: "",
        school_location: "",
        degree: "",
        field_of_study: "",
        start_date: "",
        end_date: "",
        currently_studing: false,
        description: "",
    }
    const {
        resume: {
            heading: { fname },//Used to intentify component is ignored with first call with initial-data, and react with second time component is called with user input data
            education_history,
            enabled_tabs,
            skipped_sections
        },
        handlers: {
            updateResumePreview,
            nuteralizeNextClick,
            nuteralizeBackClick,
            resumeReview
        },
        next_clicked,
        next_label,
        back_clicked,
        skip_clicked,
        toggleSkip,
        hasReviewSuggestions,
        scanReviewSuggestions
    } = useResume();

    const confirmbox = usePopup();
    const educationhistory = education_history.all
    const emptyErrorMsgs = {
        school_name: '',
        school_location: '',
    }
    const errorStyle = { color: 'red', fontSize: '10px' }
    // const dispatch = useDispatch();
    const [showToolTip, setShowToolTip] = useState(false);
    //Flag is Do Next redirect
    const [redirectNext, setredirectNext] = useState(false)
    //Flag is Do Back redirect
    const [redirectBack, setredirectBack] = useState(false)
    //Component asked to redirect, first validate
    const [callOnce, setcallOnce] = useState(false)
    const [showNameInput, setShowNameInput] = useState(false)
    const[editName, setEditName] = useState(false)


    const [skipSection, setSkipSection] = useState(false)
    //Quick edit mode
    const QEM = enabled_tabs.includes('completed')
    const label = (l) => QEM ? NEXT_LABEL : l
    const rURL = (u) => QEM ? FINAL_RESUME : u
    const skipped = (skipped_sections == undefined ? [] : skipped_sections).includes('education')

    const nextClicked = () => {
        if (skip_clicked) {
            return toggleSkip('education')
        } else if (next_clicked) {//Set for next page
            const blk = checkBlankSection()
            if(blk && !skipped) {
                confirmbox.show('section_skip',null,() => {
                    toggleSkip('education');
                    setredirectNext(true)
                })
                nuteralizeNextClick({ next_label: label(NEXT_LABEL)  })

                return false
            }else{
            nuteralizeNextClick({ next_label: label(NEXT_LABEL), skip_label: skipped ? 'Add' : 'Skip' }, true, QEM ? '' : 'skills')
            return true
            }
        } else {//Set for own page
            // if (next_clicked || next_label != label(NEXT_SKILLS_LABEL)) {
            //Always run for next click and self label not matched
            nuteralizeNextClick({ next_label: label(NEXT_LABEL), skip_label: skipped ? 'Add' : 'Skip' })
            return false
            // }
        }
    }
    const checkBlankSection = () => {
        let ids = Object.keys(educationhistory)
        let secblank = null
        if (ids.length == 1) {
            ids.forEach(ele => {
                const edu = educationhistory[ele].education
                secblank = !(
                    edu.school_name.trim().length ||
                    edu.school_location.trim().length ||
                    edu.degree.trim().length ||
                    edu.degree.trim().length ||
                    edu.field_of_study.trim().length ||
                    edu.start_date.trim().length ||
                    (edu.description.trim().length && edu.description.trim() != '<p><br></p>')
                )
            })
        }
        return secblank;
    }
    const backClicked = () => {
        if (back_clicked) {
            nuteralizeBackClick({ next_label: label(NEXT_LABEL) })
            return true
        }
    }
    const onDragEnd = result => {
        // TODO: reorder our column
        const { destination, source, draggableId } = result;
        if (!destination) return
        if (destination.droppableId === source.droppableId && destination.index === source.index) return

        let ids = Object.keys(educationhistory), all = {}
        ids.splice(source.index, 1)
        ids.splice(destination.index, 0, draggableId)
        ids.forEach(element => all[element] = { ...educationhistory[element] })
        updateResumePreview(
            {
                education_history:
                {
                    ...education_history,
                    all: { ...all },
                    edit_in_progress: education_history.edit_in_progress
                },
                current_tab: 'education'
            }
        )
        props?.review && setTimeout(() => resumeReview(), 1000);
    }

    const updateEducation = (input, id) => {
        let m = {}
        if(props.hasOwnProperty('tabOpened') && enabled_tabs.indexOf('education') == -1) {
            m = {enabled_tabs: [...enabled_tabs, 'education']}
            m.enabled_tabs.length == 5 && m.enabled_tabs.push('completed')
        }
        const education = {
            [id]: {//example education_1
                education: {
                    ...education_history.all[id].education,
                    ...input
                }
            }
        }
        updateResumePreview(
            {
                current_tab: 'education',
                education_history:
                {
                    ...education_history,
                    all: {
                        ...educationhistory,
                        ...education
                    },
                    edit_in_progress: education_history.edit_in_progress
                }, ...m

            }
        )
    }
    const addEducation = () => {
        const id = 'education_' + Math.floor(Math.random() * 1000)
        updateResumePreview(
            {
                current_tab: 'education',
                education_history:
                {
                    ...education_history,
                    all: {
                        ...educationhistory,
                        [id]: { education: { ...emptyeducation } }
                    },
                    edit_in_progress: { education: id, step: 1 }
                }
            }
        )
        props?.review && setTimeout(() => resumeReview(), 1000);

    }
    const deleteEducation = (id) => {
        if (educationhistory.hasOwnProperty(id)) {
            let t = educationhistory
            let prgs = education_history.edit_in_progress
            delete t[id]
            if (!Object.keys(t).length) {//Last need to handle with default settings
                t = { education_1: { education: { ...emptyeducation } } }
                prgs = { education: 'education_1', step: 1 }
            }
            updateResumePreview(
                {
                    current_tab: 'education',
                    education_history:
                    {
                        ...education_history,
                        all: { ...t },
                        edit_in_progress: { ...prgs }
                    }

                }
            )
            props?.review && setTimeout(() => resumeReview(), 1000);
        }
    }
    const nextStep = (id, step) => {
        updateResumePreview(
            {
                education_history:
                {
                    ...education_history,
                    all: educationhistory,
                    edit_in_progress: { education: id, step: step }
                }
            }
        )
    }
    useEffect(() => {
        if (nextClicked()) setredirectNext(true)
        else setredirectNext(false)
        if (backClicked()) setredirectBack(true)
        else setredirectBack(false)
        setcallOnce(false)
    }, [callOnce, fname]);

    useEffect(() => {
        setSkipSection(skipped_sections?.includes('education'))
    }, [skipSection, skipped_sections]);
    // nextClicked()
    useEffect(() => {
        confirmbox.configurePopup(POPUP_TYPES);
    }, []);
    const showTabOpenCloseIcon = () => (
        props.hasOwnProperty('tabOpened') ?
            <span className="open-close-btn light-green" onClick={() => {
                props.tabClicked('education', false);
                setShowNameInput(false);
                setBodyHeight();
            }}>
                {props.tabOpened ? <i className="icon-arrow-up-light"></i> : <i className="icon-arrow-down-light"></i>}
            </span> : ''
    )
    const _hasReviewSuggestions = (id, field = null) => {
        return props?.review && (
            field ? 
                hasReviewSuggestions('education_history', field, id) :
                Object.keys(scanReviewSuggestions('education_history', id )).length > 0
        )
    }
    
    const toggleSkipWrapper = (sec) => {
        toggleSkip(sec);
        props?.review && setTimeout(() => resumeReview(), 1000);
      }
    //Keep the control on multiple rendering and out of limit. Force to update once
    if ((next_clicked || back_clicked) && !callOnce) setcallOnce(true);
    if (redirectNext) { history.pushState(null, EDUCATION_LINK); return <Redirect to={rURL(SKILLS_LINK)} /> }
    if (redirectBack) return <Redirect to={rURL(WORKHISTORY_LINK)} />
 
    return (
        <div className="editor-block-inner">
            {props.splash}
            <div className="editor-area light-green-line">
                <div className="form-heading" >
                    <div className={`on-off-btn ${skipSection ? 'disabled' : 'light-green'}`} onClick={e => {
                        skipped ? toggleSkipWrapper('education') : confirmbox.show('section_skip',null,() => toggleSkipWrapper('education'))
                    }}><span><i></i></span></div>
                    {props.hasOwnProperty('tabClicked') 
                    ? <><div className="heading" onClick={() => {
                            if(!showNameInput){
                                props.tabClicked('education', editName);
                                setEditName(false);
                            }
                        }}>
                            {showNameInput 
                            ? '' 
                            : <>
                                <h1>
                                    {education_history.name ?? 'Education'} {
                                        props?.tabOpened && props.tabOpened 
                                        ? <i className="icon-pencil" onMouseOver={() => setEditName(true)} onClick={() => {
                                        setShowNameInput(true);
                                        props.tabClicked('education', editName);
                                        }}></i>
                                        : ''
                                    }
                                </h1>
                            </>
                        }
                        {showNameInput 
                            ? <input
                                type="text"
                                className="edit-block-name"
                                name="name"
                                value={education_history.name ?? 'Education'}
                                onChange={(e) => {
                                    props.tabClicked('education', true)
                                    updateResumePreview({ education_history: {...education_history, name: e.target.value }});
                                }}
                                onFocus={(e) => updateResumePreview({ education_history: {...education_history, name: e.target.value }})}
                                onBlur={(e) => {
                                    updateResumePreview({ education_history: {...education_history, name: e.target.value }})
                                    setShowNameInput(false)
                                }}
                            />
                            : '' 
                        }
                        <p>List your most relevant education first. Include programs you're currently enrolled in.</p>
                    </div></>
                    : <div className="heading" style={{cursor: "default"}}>
                            <h1>{education_history.name ?? 'Education'}</h1>
                            <p>List your most relevant education first. Include programs you're currently enrolled in.</p>
                        </div>
                    }
                    {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <div className="quick-tips light-green" id="quick-tips-btn">
                        <span
                            onClick={() => {
                                setShowToolTip(!showToolTip);
                            }}><i className="icon-lightbulb-on"></i>Quick Tips</span>
                        {showToolTip ? <QuickTips section="education_history" setShowToolTip={(showToolTip) => { setShowToolTip(showToolTip) }} /> : ''}
                    </div>}
                    {showTabOpenCloseIcon()}
                </div>

                {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <DragDropContext onDragEnd={onDragEnd}>
                    <div className="summary-listing-wrapper">
                        <Droppable droppableId={'unrelavent'} >
                            {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {Object.keys(educationhistory).map((education_id, index) => {
                                        let education = educationhistory[education_id].education
                                        //Only year found in case of linkedin profile upload
                                        education.start_date = formatDateHelper(education.start_date)
                                        education.end_date = formatDateHelper(education.end_date, false)
                                        return (
                                            <Draggable draggableId={education_id} index={index} key={education_id}>
                                                {(provided, snapshot) => (
                                                    <div className="summary-listing-row"
                                                        {...provided.draggableProps}
                                                        ref={provided.innerRef}
                                                        key={education_id}
                                                    // onClick={
                                                    //     (e) => {
                                                    //         if (['svg', 'path'].indexOf(e.target.tagName) == -1) {
                                                    //             nextStep(education_id, 1), gaTrack('RB App', `Editor: Education`, `Edit`);
                                                    //             ga4Track('app_editor_education_pencil_icon', 'RB App', `Edit`);
                                                    //         }
                                                    //     }
                                                    // }
                                                    >
                                                        <div className="row">
                                                            {education_history.edit_in_progress?.education != education_id && 
                                                            _hasReviewSuggestions(education_id) &&
                                                            <span className='suggestion-title' onClick={(e) => {
                                                                if (education_history.edit_in_progress.education == education_id) nextStep('', null);
                                                                else nextStep(education_id, 1);
                                                            }}><span class="e-exclamation"> <span class="e-circle bg-error"></span></span> View Suggestions
                                                            </span>}
                                                            <div className="reorder">
                                                                <div type="button" className="btn btn-link" dataid={education_id} {...provided.dragHandleProps}><DraggableIcon /></div>
                                                            </div>
                                                            <div className="block-details">
                                                                <h2 data-index={index + 1}><strong>{`${education.school_name}${education.degree && `, ${education.degree}`}`}</strong>
                                                                    {education.start_date ? ' | ' + education.start_date : ''}
                                                                    {education.start_date ?
                                                                        (education.currently_studying ? ` - Present` : ` ${education.end_date ? ' - ' + education.end_date : ''}`) :
                                                                        (education.currently_studying ? ` | Present` : ` ${education.end_date ? ' | ' + education.end_date : ''}`)
                                                                    }</h2>
                                                                {education_history.edit_in_progress?.education == education_id ? <p>&nbsp;</p> : <div className="desc" dangerouslySetInnerHTML={{ __html: getExcerpt(education.description) }} />}
                                                            </div>
                                                            <div className="btn-group">

                                                                <button type="button" className="dd-btn"
                                                                    onClick={(e) => {
                                                                        if (education_history.edit_in_progress.education == education_id) nextStep('', null);
                                                                        else nextStep(education_id, 1);
                                                                        gaTrack('RB App', `Editor: Education`, `Edit`);
                                                                        ga4Track('app_editor_education_pencil_icon', 'RB App', 'Edit');
                                                                    }
                                                                    } dataid={education_id} > {education_history.edit_in_progress.education == education_id ? <i className="icon-chevron-left"></i> : <i className="icon-right-arrow"></i>}
                                                                </button>
                                                                <button type="button" className="btn btn-link " onClick={(e) => {
                                                                    confirmbox.show('row_delete',null, ()=>{
                                                                        deleteEducation(education_id);
                                                                        removeBodyScroll(true);
                                                                        gaTrack('RB App', `Editor: Education`, `Delete`);
                                                                        ga4Track('app_editor_education_delete', 'RB App', 'Delete');
                                                                    }
                                                                    );
                                                                    removeBodyScroll(true);
                                                                    // window.confirm(
                                                                    //     "Are you sure to delete this education summary?"
                                                                    // ) && deleteEducation(education_id), gaTrack('RB App', `Editor: Education`, `Delete`), ga4Track('app_editor_education_delete', 'RB App', 'Delete');
                                                                }} dataid={education_id}><DeleteIcon className="icon-blue" /></button>
                                                            </div>
                                                        </div>
                                                        {education_history.edit_in_progress?.education == education_id ?
                                                            <AddEducation
                                                                data={education}
                                                                id={education_id}
                                                                updateEducation={updateEducation}
                                                                _hasReviewSuggestions={_hasReviewSuggestions}
                                                                review = {props?.review}
                                                                reviewIt={() => props?.review && setTimeout(() => resumeReview(), 1000)}
                                                            /> : ''
                                                        }
                                                    </div>
                                                )}
                                            </Draggable>
                                        )
                                    })}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                        <div className="add-more-btn-cover">
                    <button className="btn-link-style light-green" onClick={() => {
                        addEducation();
                        gaTrack('RB App', `Editor: Education Summary`, 'Add One More');
                        ga4Track('app_editor_education_add_one_more', 'RB App', 'Add One More');
                    }}><PlusIcon /> <span>Add more education</span></button>
                </div>
                    </div>
                </DragDropContext>}

            </div></div >);
}
export default Summary;